<template>
  <div class="form-group tinymceLoading">
    <label
      class="col-form-label col-sm-12"
      v-if="nolabel !== true"
      style="padding-left:0"
    >{{ title || '&nbsp;' }}</label>
    <textarea class="col-sm-12" :id="id" ></textarea>

    <label
      v-if="isValid === false"
      id="basic-error"
      class="validation-invalid-label"
      for="basic"
    >This field is required.</label>
  </div>
</template>
<script>
import helper from "@/vueHelper"
export default {
  name: "richtext",
  props: [
    "title",
    "placeholder",
    "value",
    "maxlength",
    "readonly",
    "labelwidth",
    "required",
    "nolabel"
  ],
  created() {
    this.id = "tinymceeditor" + this.$helper.genUUID();
  },
  mounted() {
    let $vm = this;
    helper.loading(".tinymceLoading");

    this.$nextTick(() => {
      tinymce.init({
        selector: "textarea#" + $vm.id,
        autoresize_min_height: 400,
        autoresize_max_height: 800,
        menubar: true,
        plugins: ["table code autoresize link"],
        branding: false,
        skin: "oxide",
        theme: "silver",
        init_instance_callback: function(editor) {
          helper.done(".tinymceLoading");
          editor.setContent($vm.content);
          editor.on("Paste Change input Undo Redo", function(e) {
            $vm.$emit("input", editor.getContent());
          });
        }
      });
    });
  },
  beforeDestroy() {
    tinymce.remove("#" + this.id);
    // tinymce.execCommand('mceRemoveControl', true, this.id);
  },
  computed: {
    getRichText() {
      return window.tinymce ? window.tinymce : null;
    }
  },
  data() {
    return {
      id: "",
      content: "",
      isValid: true,
      init:false,
    };
  },
  methods: {
    updateData(val) {
      this.content = val || "";
      if(tinymce&&tinymce.get(this.id)){   
        tinymce.get(this.id).setContent(this.content );
      }
    },
  },
  components: {},
  watch: {
    value:{
      handler(val){
        if(val&&!this.init){
        this.updateData(val);
        this.init = true;
      }
      },
      immediate:true
    }
  }
};
</script>

<style>
.tox-notification { display: none !important } 
</style>